<template>
    <svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Comps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="icon--star" transform="translate(-773.000000, -1762.000000)" :stroke="strokeColor"  :fill="fillColor">
                <path d="M786.597824,1777.32836 L785.606936,1772.17196 L789.439436,1768.58278 L784.229209,1767.93176 L782,1763.17771 L779.770791,1767.93176 L774.560564,1768.58278 L778.393064,1772.17196 L777.402176,1777.32836 L782,1774.79256 L786.597824,1777.32836 Z" id="Star"></path>
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    name: "IconStar",
    computed: {
        fillColor() {
            return this.fill == 'orange' ? '#E75300' : this.fill == 'white' ? '#FFFFFF' : 'none';
        },
        strokeColor() {
            return this.fill == 'orange' ? '#E75300' : '#FFFFFF';
        }
    },
    props: {
        fill: {
            type: String,
            default: 'none'
        }
    }
};
</script>
<style lang="scss">

</style>
